import { useStations } from './queries/stationQueries';
import { useDRResourcesBatch } from './queries/drResourceQueries';
/**
 * 충전소 데이터를 간결하게 사용하는 헬퍼 훅
 * @param {Object} params - 쿼리 파라미터
 * @returns {Object} 충전소 데이터와 관련 정보
 */
const useStationsSimple = (params = {}) => {
  const { data: stationsData, isLoading: stationsLoading, error } = useStations(params);
  const stations = stationsData?.Items || [];
  
  const drResourceIds = stations.map(station => station.DrResourceSysId).filter(Boolean);
  const { data: drResources = [], isLoading: drResourcesLoading } = useDRResourcesBatch(drResourceIds);
  
  return {
    stations,
    drResources,
    isLoading: stationsLoading || drResourcesLoading,
    error,
    getStationById: (stationId) => stations.find(s => s.StationSysId === stationId),
    getDrResourceById: (drResourceId) => drResources.find(drResource => drResource?.DrResourceSysId === drResourceId),
    totalCount: stationsData?.Total || stations.length,
  };
};

export default useStationsSimple;